export default {"src":"/_next/static/media/arrow-right.39da3779.svg","height":22,"width":26};